import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-BookItalicNew.woff2';
import woff from '../src/PPMori-BookItalicNew.woff';

export const ppMoriBookItalic: FontFaceSpec = {
  weight: 350,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
